/**
 * Container management for transcript
 */

import { setContainerElements, transcriptContainer } from './state.js';

/**
 * Initialize transcript container in audio player
 * @param {jQuery} playerElement - Audio player jQuery element
 */
export function initTranscriptContainer(playerElement) {
	if (!playerElement || !playerElement.length) {
		console.warn('[Transcript] ⚠️ No player element provided');
		return;
	}
	
	// Check if container already exists
	if (playerElement.find('.audio-player__transcript').length) {
		return;
	}
	
	// Create transcript container (only language links, no text container)
	const transcriptHtml = `
		<div class="audio-player__transcript" style="display: none;">
			<div class="audio-player__transcript-languages"></div>
		</div>
	`;
	
	// Insert after audio element (inside content)
	const contentElement = playerElement.find('.audio-player__content');
	
	contentElement.append(transcriptHtml);
	
	const container = playerElement.find('.audio-player__transcript');
	const langContainer = playerElement.find('.audio-player__transcript-languages');
	
	setContainerElements(container, langContainer);
}

/**
 * Show transcript container
 */
export function showTranscriptContainer() {
	if (!transcriptContainer) {
		return;
	}
	
	transcriptContainer.show();
	
	// Adjust player height to fit content (auto height)
	const playerElement = transcriptContainer.closest('.audio-player-overlay');
	if (playerElement && playerElement.length) {
		// Use auto height to adapt to content
		playerElement.css({
			height: 'auto'
		});
	} else {
		console.warn('[Transcript] ⚠️ Player element not found');
	}
}

/**
 * Hide transcript container
 */
export function hideTranscriptContainer() {
	if (!transcriptContainer) return;
	
	transcriptContainer.hide();
	// Adjust player height to fit content (auto height)
	const playerElement = transcriptContainer.closest('.audio-player-overlay');
	if (playerElement && playerElement.length) {
		playerElement.css({
			height: 'auto'
		});
	}
}

